import { AttributesConfigurationDc, GeometryType, PostgresLayerServiceConfigurationDc } from "@evergis/api";

import { DEFAULT_ID_ATTRIBUTE_NAME, GEOMETRY_ATTRIBUTE } from "../../constants";

import { getServiceConfiguration } from "./getServiceConfiguration";

export const getAttributesConfiguration = (layer): AttributesConfigurationDc => {
  const serviceConfiguration = getServiceConfiguration(layer);
  const emptyAttributesConfiguration: AttributesConfigurationDc = {
    geometryAttribute: layer?.geometryType === GeometryType.Unknown ? void 0 : GEOMETRY_ATTRIBUTE,
    idAttribute: DEFAULT_ID_ATTRIBUTE_NAME,
    tableName: "",
  };

  if (!("attributesConfiguration" in serviceConfiguration)) {
    return emptyAttributesConfiguration;
  }

  return {
    ...emptyAttributesConfiguration,
    ...((serviceConfiguration as PostgresLayerServiceConfigurationDc).attributesConfiguration || {}),
  };
};
